import * as Contentstack from 'contentstack';
const Stack = Contentstack.Stack(
    process.env.REACT_APP_API_KEY,
    process.env.REACT_APP_DELIVERY_TOKEN,
    process.env.REACT_APP_ENVIRONMENT
);

export const getCornBidsContent = (store) => {
    let cornbids = {
        cornbids_status: 'INITIAL',
    };
    cornbids.cornbids_status = 'LOADING';
    store.setState({ cornbids });
    try {
        //Contact page query
        const CornbidsQuery = Stack.ContentType('corn_bids').Query();
        CornbidsQuery.includeReference(['corn_bids_config'])
            .toJSON()
            .find()
            .then(
                function success(result) {
                    const cornbidsData = result[0];
                    const isContentEmpty = cornbidsData.length == 0;
                    cornbids = isContentEmpty ? cornbids : cornbidsData[0];
                    cornbids.cornbids_status = isContentEmpty
                        ? 'EMPTY'
                        : 'SUCCESS';
                    store.setState({
                        cornbids,
                    });
                },
                function error(err) {
                    const isError404 =
                        error.response && error.response.status === 404;
                    cornbids.cornbids_status = isError404
                        ? 'NOT_FOUND'
                        : 'ERROR';
                    store.setState({ cornbids });
                }
            );
    } catch (error) {
        store.setState({ status: 'ERROR`' });
    }
};
